export const firebase_config_prod = {
  apiKey: "AIzaSyD9x_VCAGlwNawUr5zcjn-oVg8xlkbMHHI",
  authDomain: "iventer.firebaseapp.com",
  databaseURL: "https://iventer.firebaseio.com",
  projectId: "iventer",
  storageBucket: "iventer.appspot.com",
  messagingSenderId: "553520821210"
};
